export default __webpack_public_path__ + "static/media/tv.50115466.mp4";